import "./BootstrapCSS.scss";
export default function BootstrapCSS() {
	return null;
}
